<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 27 41"
    xml:space="preserve"
    class="marker-icon"
  >
    <g transform="translate(3.0, 29.0)">
      <ellipse
        class="st0"
        cx="10.5"
        cy="5.8"
        rx="10.5"
        ry="5.3"
      />
      <ellipse
        class="st0"
        cx="10.5"
        cy="5.8"
        rx="10.5"
        ry="5.3"
      />
      <ellipse
        class="st0"
        cx="10.5"
        cy="5.8"
        rx="9.5"
        ry="4.8"
      />
      <ellipse
        class="st0"
        cx="10.5"
        cy="5.8"
        rx="8.5"
        ry="4.3"
      />
      <ellipse
        class="st0"
        cx="10.5"
        cy="5.8"
        rx="7.5"
        ry="3.8"
      />
      <ellipse
        class="st0"
        cx="10.5"
        cy="5.8"
        rx="6.5"
        ry="3.3"
      />
      <ellipse
        class="st0"
        cx="10.5"
        cy="5.8"
        rx="5.5"
        ry="2.3"
      />
      <ellipse
        class="st0"
        cx="10.5"
        cy="5.8"
        rx="4.5"
        ry="2.3"
      />
    </g>
    <path
      fill="currentColor"
      d="M13.5,0C6,0,0,6,0,13.5c0,1.6,0.5,3.4,1.4,5.3c0.2,0.4,0.4,0.8,0.6,1.3c0.5,0.9,1,1.7,1.5,2.6c2.4,3.8,5.7,7.9,8.6,11.8c0.4,0.5,0.8,0.8,1.3,0.8c0.4,0,0.8-0.3,1.2-0.8c3-4,6.3-8.1,8.7-11.9c0.6-0.9,1.1-1.8,1.5-2.6c0.2-0.4,0.4-0.8,0.6-1.3c0.9-1.9,1.4-3.6,1.4-5.2C27,6,21,0,13.5,0z M13.5,20.5c-3.9,0-7-3.1-7-7s3.1-7,7-7s7,3.1,7,7S17.4,20.5,13.5,20.5z"
    />
    <path
      class="st2"
      d="M13.5,0C6,0,0,6,0,13.5c0,1.6,0.5,3.4,1.4,5.3c0.2,0.4,0.4,0.8,0.6,1.3c0.5,0.9,1,1.7,1.5,2.6c2.4,3.8,5.7,7.9,8.7,11.8c0.4,0.5,0.8,0.7,1.2,0.8c0.5,0,0.9-0.2,1.3-0.8c2.9-4,6.2-8.1,8.6-11.9c0.6-0.9,1.1-1.8,1.5-2.6c0.2-0.4,0.5-0.8,0.6-1.3c0.9-1.9,1.4-3.6,1.4-5.2C27,6,21,0,13.5,0z M22.2,22.7c-2.3,3.5-5.5,7.4-8.3,11.2c-0.2,0.3-0.3,0.4-0.4,0.5c-0.1-0.1-0.2-0.3-0.4-0.5c-2.8-3.8-5.6-7.6-8-11.1C2.7,19.3,1,16,1,13.5C1,6.6,6.6,1,13.5,1S26,6.6,26,13.5C26,15.9,24.5,19.2,22.2,22.7z"
    />
    <circle
      class="st3"
      cx="13.5"
      cy="13.5"
      r="7.5"
    />
  </svg>
</template>

<script setup lang="ts" scoped></script>

<style lang="scss" scoped>
.st0 {
  opacity: 0.03;
}
.st2 {
  opacity: 0.2;
}
.st3 {
  fill: none;
  stroke: #000000;
  stroke-miterlimit: 10;
  stroke-opacity: 0.2;
}

svg {
  $size: 3rem;
  width: $size;
  height: $size;
  color: $primary-color;
  cursor: pointer;
}


</style>
